import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "@tsp-core/store/utils";

import { CountriesDictionary, CountryAlpha2Code, CountryUuid } from "../types";

export type GetCountriesResponseData = {
  items: Array<{
    uuid: CountryUuid;
    name: string;
    alpha2Code: CountryAlpha2Code;
    alpha3Code: string;
    companyCreationAllowed: boolean;
  }>;
};
export const countriesApi = createApi({
  reducerPath: "@countries/api",
  baseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  refetchOnMountOrArgChange: false,
  keepUnusedDataFor: 60 * 60 * 24,
  endpoints: (builder) => ({
    getCountriesDictionary: builder.query<CountriesDictionary, void>({
      query: () => ({
        url: "/settings/countries",
        method: "POST",
      }),
      transformResponse: (response: GetCountriesResponseData) => {
        return response.items.reduce((accumulator, item) => {
          accumulator[item.uuid] = {
            uuid: item.uuid,
            name: item.name,
            alpha2Code: item.alpha2Code,
            isAllowedForCompanyCreation: item.companyCreationAllowed,
          };
          return accumulator;
        }, {} as CountriesDictionary);
      },
    }),
  }),
});
